import { observer, use$ } from '@legendapp/state/react';
import { Button, SimpleGrid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { autoBetState$ } from '../../state/auto-bet.state';
import { manualBetState$ } from '../../state/manual-bet.state';
import { uiState$ } from '../../state/ui.state';

export const GameAsideTabs = observer(() => {
  const activeTab = use$(uiState$.activeTab);
  const isManualBetting = use$(manualBetState$.isBetting);
  const isAutoBetting = use$(autoBetState$.isAutoBetting);
  const { t } = useTranslation();
  const isManualSelected = activeTab === 'manual';
  const isAutoSelected = activeTab === 'auto';

  return (
    <SimpleGrid cols={2} data-test-id="tab-select-container">
      <Button
        data-test-id="manual-tab-button"
        disabled={isManualBetting || isAutoBetting}
        onClick={() => uiState$.setActiveTab('manual')}
        styles={(theme) => ({
          root: {
            borderWidth: 2,
            height: 40,
            borderColor: isManualSelected
              ? theme.colors.brand[5]
              : 'transparent',
          },
        })}
        variant={isManualSelected ? 'outline' : 'default'}
      >
        {t('gameTabs.manual')}
      </Button>
      <Button
        data-test-id="auto-tab-button"
        disabled={isManualBetting || isAutoBetting}
        onClick={() => uiState$.setActiveTab('auto')}
        styles={(theme) => ({
          root: {
            borderWidth: 2,
            height: 40,
            borderColor: isAutoSelected ? theme.colors.brand[5] : 'transparent',
          },
        })}
        variant={isAutoSelected ? 'outline' : 'default'}
      >
        {t('gameTabs.auto')}
      </Button>
    </SimpleGrid>
  );
});
